import { yupResolver } from "@hookform/resolvers/yup";
import React, { useMemo } from "react";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { AiOutlineClose } from "react-icons/ai";
import { centered } from "../../styles/globalStyles";
import { AnyObject } from "yup/lib/types";
import { DimType, Dimensions } from "../../pages/Calculator/Calculator";
import Button from "../Button";
import NumericInput from "../NumericInput";
import { RequiredStringSchema } from "yup/lib/string";

interface Props {
  dimType: DimType;
  roomName: string;
  roomCount: number;
  showModal: boolean;
  toggleModal: () => void;
  toggleDimType: () => void;
  onDimensionsSubmit: (val: Dimensions[]) => void;
}

const DimensionsForm = ({
  onDimensionsSubmit,
  toggleDimType,
  toggleModal,
  showModal,
  roomCount,
  roomName,
  dimType,
}: Props) => {
  const schema = useMemo(() => {
    const schema: {
      [key: string]: RequiredStringSchema<string | undefined, AnyObject>;
    } = {};

    for (let i = 1; i <= roomCount; i++) {
      schema[`room_${i}`] = yup.string().required("Provide this field");
    }

    return yup.object(schema);
  }, [roomCount]);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<{ [key: string]: number }>({
    resolver: yupResolver(schema),
    reValidateMode: "onChange",
  });

  const submitHandler = handleSubmit((data) => {
    const dimensions: Dimensions[] = [];
    // 1. prepare the data
    for (const [key, value] of Object.entries(data)) {
      dimensions.push({ units: Number(key.split("_")[1]), size: value });
    }
    // 2. submit dimensions
    onDimensionsSubmit(dimensions);
    toggleModal();
  });

  if (!showModal) return <></>;

  return (
    <>
      <div
        key={roomName}
        className="`fixed z-10 bg-black w-full h-screen top-0 left-0 opacity-90 md:hidden
          "
      />
      <form
        onSubmit={submitHandler}
        className={
          "absolute bg-white rounded-lg p-5 bottom-0 shadow-xl w-11/12 md:w-3/4 z-20 flex-col" +
          centered
        }
      >
        <div className="flex justify-end items-center w-full">
          <AiOutlineClose
            className="text-gray-500 font-Bold cursor-pointer hover:opacity-80"
            onClick={toggleModal}
          />
        </div>
        <p className="text-strongBlue capitalize text-lg font-medium text-center">
          Specify {roomName} Dimensions{" "}
        </p>
        <div className="bg-gray-200 p-1 rounded-md">
          <strong
            className={`p-1 rounded-md cursor-pointer text-xs ${
              dimType === "sqm" ? "bg-green-600 text-white" : "text-green-500"
            }`}
            onClick={toggleDimType}
          >
            sqm
          </strong>
          <strong
            className={`p-1 rounded-md cursor-pointer text-xs ${
              dimType === "sqft" ? "bg-green-600 text-white" : "text-green-500"
            }`}
            onClick={toggleDimType}
          >
            sqft
          </strong>
        </div>
        <div className="grid grid-cols-2 gap-y-7 gap-x-5 my-5 max-h-40 overflow-y-scroll py-6">
          {React.Children.toArray(
            Array.from({
              length: roomCount,
            }).map((_, i) => (
              <NumericInput
                type="number"
                label={`Room ${i + 1}`}
                placeholder="eg. 15"
                ContainerClassName="-my-1"
                register={register(`room_${i + 1}`)}
                error={errors[`room_${i + 1}`]?.message}
              />
            ))
          )}
        </div>
        <Button
          text="Submit"
          className="mt-0"
          onClick={submitHandler}
          type={isValid ? "primary" : "muted"}
        />
      </form>
    </>
  );
};

export default DimensionsForm;
